import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import './storyListingFooter.scss';
import './storyListingTable.scss';
import './storyListingCheckboxDropdown.scss';
import Footer from '../Footer/footer';
import Header from '../Header/header';
import { auth as AuthObject } from '../../services/login'
import '../Header/header.scss';
import cookie from '../../cookieHelper/cookie';
import toastNotify from '../../utils/toastNotifier';


import getPurchaseStories from '../../services/purchase/getPurchaseStories';
import getStoriesByCompanyID from '../../services/getStoriesByCompanyID';
import deleteStory from '../../services/deleteStory';
import deletePurchaseStory from '../../services/purchase/deletePurchaseStory';
import repostStory from '../../services/repostStory';
import repostPurchaseStory from '../../services/purchase/repostPurchaseStory';

import bulkPublish from '../../services/story/bulkPublish';

import PopulateCompanyList from '../CompanyList/companyList';
import getCompanies from '../../services/getCompanyList';
import calculateDateInFormat from '../../utils/calculateDate';

import EmptyScreen from '../../components/EmptyScreen/EmptyScreen';
import withRouter from '../withRouter';

class Story extends React.Component {
    constructor() {
        super();
        this.state = {
            companyID: '',
            currentCompanyID: '',
            companies: [],
            purchasePage: 0,
            purchaseTotal: 0,
            purchaseLoading: false,
            purchaseError: '',
            tokencheck:true

        }
        // this.checkAuth();
        this.multiStories;
        this.publishStoriesData;

        this.multipleCheckboxes;
        this.flag = false;
        this.companyListing;
    }

    statusMap = {
        0: "Deleted",
        1: "Active",
        2: "Expired",
        3: "Saved as Draft"
    }

    checkAuth = () => {
        AuthObject.authenticate(() => {
            if (cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)) {
                console.log("cookie found");

                this.setState(() => ({
                    redirectToReferrer: true
                }))
            }
        })
    }

    redirectHandlerAddStory = () => {
        // console.log("in redirectHandler");  
        this.setState({
            redirectToAddStory: true
        })
    }

    redirectHandlerAllStory = () => {
        // console.log("in redirectHandler");  
        this.setState({
            redirectToAllStory: true
        })
    }

    setCompanyID = (e) => {
        console.log("comapnyytID: ", e.target.value);

        this.setState({
            companyID: e.target.value
        })
    }
    componentWillUnmount() {
        this.purchaseController?.abort();
    }

    loadPurchaseStories = async (page = 0) => {
        this.purchaseController?.abort();
        const controller = new AbortController();
        this.purchaseController = controller;
        this.setState({ purchaseLoading: true, purchaseError: '', companyList: [], purchasePage: page });
        try {
            const result = await getPurchaseStories(this.props.params.purchaseId, page, 10, controller.signal);
            if (!controller.signal.aborted) {
                this.setState({ companyList: result.stories, purchaseTotal: result.total });
            }
        } catch (error) {
            if (controller.signal.aborted) return;
            const code = String(error.response?.data?.status?.code);
            if (error.response?.status === 401 || ['10411', '10412', '10416', '10417'].includes(code)) {
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
                this.setState({ tokencheck: false });
            } else {
                this.setState({ purchaseError: 'Unable to load stories. Please try again.' });
            }
        } finally {
            if (!controller.signal.aborted) this.setState({ purchaseLoading: false });
        }
    };

    componentDidUpdate(prevProps) {
        if (this.props.params.purchaseId !== prevProps.params.purchaseId && this.props.params.purchaseId) {
            this.loadPurchaseStories();
        }
        if (this.flag == true) {
            var removeAdminData = document.querySelectorAll(".adminDataHidden");
            for (var index = 0; index < removeAdminData.length; index++) {
                var adminData = removeAdminData[index];

                adminData.classList.remove("adminDataHidden");
            }

        }

    }
    componentDidMount() {
        var elem = document.getElementById("sl");
        elem?.classList.add("active");
        this.loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
        console.log("Inside allCompamyStories Function:", this.loginProfileInfo.email);
        // var flag = false;
        var admins = ["triptee@iimjobs.com", "bharat@iimjobs.com", "puneet.pant@iimjobs.com", "minisha@iimjobs.com"];
        // var admins = ["test_123@iimjobs.com"];
        // console.log(admins.length);
        for (var i = 0; i < admins.length; i++) {
            // console.log(admins[i]);
            if (admins[i] === this.loginProfileInfo.email) {
                this.flag = true;
            }
        }
        console.log("flag:", this.flag);
        if (this.flag == true) {
            var removeAdminChecks = document.querySelectorAll(".adminCheckHidden");
            console.log("removeAdminChecks.length:", removeAdminChecks.length);

            // var removeAdminData = document.querySelectorAll(".adminDataHidden");
            // console.log("removeAdminData.length:", removeAdminData.length);

            for (var index = 0; index < removeAdminChecks.length; index++) {
                var admin = removeAdminChecks[index];
                // admin.style.display="table-cell";
                admin.classList.remove("adminCheckHidden");
            }

        }
        if (this.props.params.purchaseId) {
            this.loadPurchaseStories();
            return;
        }
        let list = {};

        const companyList = async () => {
            let companiesResult = await getCompanies();

            if (!(companiesResult instanceof Error)) {
                if (companiesResult.status.code == "10200") {
                    list = companiesResult.data[0];

                    console.log("companyList: ", list);
                    this.getList = list;
                    // console.log(list.companies.length);
                    // let companyListing = <option>No company Found</option>;
                    // var companyListing = document.createElement('select');
                    if (typeof list === 'undefined') {
                        // console.log("if ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (Object.keys(list).length === 0) {
                        // console.log("else if-1 ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (list.companies.length) {
                        // console.log("else if-2 ran");
                        let teamsFromApi = list.companies.map(item => { return { value: item.id, display: item.companyName } })
                        this.setState({ companies: [{ value: '', display: 'Select Company' }].concat(teamsFromApi) });
                    }
                    else {
                        // console.log("else ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                } else {
                    toastNotify("3", "Some error occured while fetching companies list")
                }
            } else {

                const response = JSON.parse(companiesResult.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                else{
                    toastNotify("3", "Some error occured while fetching companies list")

                }
            }
        }

        companyList();

    }
    // 
    eventHandleClick() {
        // var ui = document.querySelector(".profile-menu");
        // var conui=document.querySelector(".container");

        var ui = document.querySelector(".profile-menu");
        if (ui) ui.style.display = "none";
    }

    onSubmit = async (e) => {
        e.preventDefault();

        // this.setState({ stories: [] });


        const data = {
            companyId: this.state.companyID,
        }

        this.validateData(data, e)
    }

    editRedirectHandler = (storyId) => {
        this.setState({
            redirectToEdit: true,
            storyId: storyId
        })
    }

    onDelete = async (e, storyId, index) => {
        e.preventDefault();

        if (this.props.params.purchaseId) {
            if (this.deletingPurchaseStory) return;
            this.deletingPurchaseStory = true;
            try {
                await deletePurchaseStory(this.props.params.purchaseId, storyId);
                toastNotify(1, "Successfully deleted story");
                const page = this.state.companyList.length === 1 && this.state.purchasePage > 0
                    ? this.state.purchasePage - 1 : this.state.purchasePage;
                await this.loadPurchaseStories(page);
            } catch (error) {
                const code = String(error.response?.data?.status?.code);
                if (error.response?.status === 401 || ['10411', '10412', '10416', '10417'].includes(code)) {
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                    this.setState({ tokencheck: false });
                } else {
                    toastNotify(3, error.response?.data?.status?.message || "Couldn't delete story");
                }
            } finally {
                this.deletingPurchaseStory = false;
            }
            return;
        }

        try {
            let result = await deleteStory(storyId);


            if(result  && result["status"]==200)
            {
                const companyLists = this.state.companyList;
                const companyListing = this.state.companyList[index];
    
                companyListing.status = 0;
    
                companyLists[index] = companyListing;
    
                toastNotify(1, "Successfully deleted story");
    
                this.setState({
                    companyList: companyLists
                })
    
            }
            else{
                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }

            }
           
        }
        catch (err) {
            console.log(err);
            toastNotify(3, "Couldn't delete story");
        }
    }
    onRepost = async (e, storyId, index) => {
        if (this.props.params.purchaseId && this.repostingPurchaseStory) return;
        if (this.props.params.purchaseId) this.repostingPurchaseStory = true;
        try {
            let loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
            let createdBy = loginProfileInfo.id;
            let result = this.props.params.purchaseId
                ? await repostPurchaseStory(this.props.params.purchaseId, storyId, createdBy)
                : await repostStory(storyId, createdBy);

            if (result && result["status"] == 200) {
                toastNotify(1, "Successfully reposted story");
                if (this.props.params.purchaseId) {
                    await this.loadPurchaseStories(this.state.purchasePage);
                } else {
                    document.getElementById("btnSubmit").click();
                }
            }
            else {
                
                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }



                toastNotify(3, `Couldn't Repost story : ${result.message}`);
            }
        }
        catch (err) {
            console.log(err);
            const code = String(err.response?.data?.status?.code);
            if (this.props.params.purchaseId && (err.response?.status === 401 || ['10411', '10412', '10416', '10417'].includes(code))) {
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
                this.setState({ tokencheck: false });
            } else {
                toastNotify(3, `Couldn't Repost story : ${err.message}`);
            }
        } finally {
            this.repostingPurchaseStory = false;
        }
    }

    selectMultipleStories = () => {
        this.multipleCheckboxes = document.getElementsByName("multipleStory");

        var publishButton = document.querySelector(".publishButton");

        var vals = "";
        for (var i = 0, n = this.multipleCheckboxes.length; i < n; i++) {
            if (this.multipleCheckboxes[i].checked) {
                vals += "," + this.multipleCheckboxes[i].value;
            }
        }
        if (vals) vals = vals.substring(1);

        this.multiStories = vals.replace(/\s+/g, "");

        if (this.multiStories.length) {
            publishButton.classList.remove("hidden")
        }
        else {
            publishButton.classList.add("hidden")
        }
    }

    onPublish = async (e) => {
        e.preventDefault();

        if (!this.state.companyID) {
            alert("Please select a company");
        }
        else if (this.state.companyID != this.state.currentCompanyID) {
            alert("The company Id has been changed since last selection");
        }
        else {
            this.publishStoriesData = {
                companyId: this.state.companyID,
                storyIds: this.multiStories
            }


            // console.log("publish stories data: ", this.publishStoriesData);


            try {
                let result = await bulkPublish(this.publishStoriesData);
                // console.log("bulk publish result: ", result);

                if (result.status.code) {
                    const companyLists = this.state.companyList;
                    for (var i = 0, n = this.multipleCheckboxes.length; i < n; i++) {
                        if (this.multipleCheckboxes[i].checked) {
                            var index = this.multipleCheckboxes[i].closest("tr").getAttribute("rowindex");

                            const companyListing = this.state.companyList[index];

                            companyListing.status = 1;

                            companyLists[index] = companyListing;
                            // console.log(storyId + " has been added");
                        }
                    }
                    toastNotify(1, "Successfully added stories");
                    this.setState({
                        companyList: companyLists
                    })
                }

            }
            catch (err) {
                console.log(err);
                toastNotify(3, "Couldn't add stories");
            }
        }
    }

    validateData = async (data, e) => {
        e.persist();
        if (data.companyId == "") {
            alert("Please select a company");
        }
        else {
            let result = await getStoriesByCompanyID(data.companyId);
            console.log("result", result);
            // this.state.companyList = value;

            if (result.length) {
                let rows = result.map((item, index) => {
                    return {
                        storyType: item.storyType,
                        s3Path: item.s3Path,
                        status: item.status,
                        publishOn: item.publishOn
                    }
                })
                this.setState({
                    companyList: result,
                    rows: rows,
                    currentCompanyID: this.state.companyID
                })
            }
            else {
                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
                this.setState({
                    companyList: [],
                    rows: [],
                    currentCompanyID: ''
                })
                toastNotify(3, "No story found for this company");
                
            }
        }
    }

    render() {
        const purchaseId = this.props.params.purchaseId;

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }


        let toShowPublishType = false;
        if (this.state.companyList) {
            toShowPublishType = this.state.companyList.findIndex(x => x.storyType == 2) !== -1;
        }

        if (this.state.redirectToAddStory) {
            return <Navigate to={'/storyListing'} />
        }
        else if (this.state.redirectToAllStory) {
            return <Navigate to={'/allStories'} />
        }
        else if (this.state.redirectToEdit) {
            return <Navigate to={`/editStory/${this.state.storyId}`} />
        }

        let activeStoryRows;
        let emptyScreen = null;

        if (this.state.companyList && this.state.companyList.length) {
            activeStoryRows = (
                this.state.companyList.map((item, index) => {
                    let videoClassName, imageClassName, buttonClassName, publishButtonClassName, multiSelectOption, repostClassName = "hidden", repostButtonTitle = "", repostDisable = false;

                    if (item.storyType == 1) {
                        videoClassName = "videoComponent hidden";
                        imageClassName = "imageComponent";
                    }
                    else if (item.storyType == 2) {
                        videoClassName = "videoComponent";
                        imageClassName = "imageComponent hidden";
                    }

                    if (item.status == 1) {
                        buttonClassName = "btn-default color_danger";
                        // publishButtonClassName = "btn-default color_green";
                        // publishButtonClassName = "hidden";
                        multiSelectOption = "hidden";
                    }
                    else if (item.status == 3) {
                        buttonClassName = "btn-default color_danger";
                        // publishButtonClassName = "btn-default color_green";
                        multiSelectOption = "story-select";
                    }
                    else {
                        buttonClassName = "hidden";
                        // publishButtonClassName = "btn-default color_green";
                        // publishButtonClassName = "hidden";
                        multiSelectOption = "hidden";
                        repostClassName = "btn-default repost-btn";
                        if (item.newStoryId && item.newStoryId.length > 0) {
                            repostClassName += " disabled";
                            repostButtonTitle = "Already Reposted";
                            repostDisable = true;
                        }
                    }

                    // if(!item.publishOn){
                    //     item.publishOn = "Not Yet Published"    
                    // }

                    return (

                        <tr key={index} rowindex={index}>
                            {/* <td>
                            <div className={multiSelectOption} onChange={this.selectMultipleStories}>
                                <div className="checkbox small">
                                    <label>
                                        <input type="checkbox" name="multipleStory" value={item.storyId}/>
                                    </label>
                                </div>
                            </div>
                        </td> */}
                            <td>
                                <p>{item.storyId}</p>
                            </td>
                            <td>
                                <div className={videoClassName}>
                                    <video width="200" height="200" controls key={item.s3Path}>
                                        <source src={item.s3Path} type="video/mp4" />
                                    </video>
                                </div>
                                <div className={imageClassName}>
                                    <img src={item.s3Path} />
                                </div>

                            </td>
                            <td>
                                {item.thumbnailUrl && <img src={item.thumbnailUrl} alt="Thumbnail" style={{width: '190px', height: '200px'}} />}
                            </td>
                            {
                                toShowPublishType && (
                                    <td>
                                        <p>{item.publishType == 2 ? 'reel' : 'story'}</p>
                                    </td>
                                )
                            }
                            <td>
                                <p>{this.statusMap[item.status]}</p>
                            </td>
                            <td>
                                <p>{item.publishOn}</p>
                            </td>
                            <td>
                                <button className={buttonClassName} onClick={(e) => this.editRedirectHandler(item.storyId)}>Edit</button>
                                <button className={buttonClassName} onClick={(e) => this.onDelete(e, item.storyId, index)}>Delete</button>
                                <button className={repostClassName} title={repostButtonTitle} disabled={repostDisable} onClick={(e) => this.onRepost(e, item.storyId, index)}>Repost</button>
                                {/* <button className={publishButtonClassName}>Publish</button> */}
                            </td>
                            <td className="adminDataHidden">
                                <p>{calculateDateInFormat(item.createdOn)}</p>
                            </td>
                            <td className="adminDataHidden">
                                <p>{calculateDateInFormat(item.expiryOn)}</p>
                            </td>
                            <td>
                                <p>{item.totalClapCount}</p>
                            </td>
                            <td>
                                <p>{item.totalViewCount}</p>
                            </td>
                            <td>
                                <p>{item.totalScrollCount}</p>
                            </td>
                            <td>
                                <div>
                                    <a href={'/insights/' + item.storyId} target="_blank" className="btn-default">Show Insights</a>
                                </div>
                                <div> {item.status===1 && ( <a href={'/story/preview/' + item.publishOn + '/' + item.companyId + '/' + item.storyId + '?publishType=' + item.publishType} target="_blank" className="btn-default"> Preview</a>)}

                                    {item.status === 1 && (<button onClick={() => {
                                        const url = `${window.location.origin}/story/preview/${item.publishOn}/${item.companyId}/${item.storyId}?publishType=${item.publishType}`;

                                        const tempTextArea = document.createElement('textarea');
                                        tempTextArea.value = url;
                                        tempTextArea.style.position = 'fixed';
                                        tempTextArea.style.opacity = 0;
                                        document.body.appendChild(tempTextArea);
                                        tempTextArea.select();
                                        try {
                                            const successful = document.execCommand('copy');
                                            const msg = successful ? 'successful' : 'unsuccessful';
                                            if (successful) {
                                                toastNotify(1, "Link Copied");
                                            }
                                            else {
                                                toastNotify(1, "Unable to copy");
                                            }
                                        } catch (err) {
                                            console.error('Unable to copy', err);
                                        }
                                        document.body.removeChild(tempTextArea);
                                    }} className="btn-default">Copy  </button>)}
                                </div>

                            </td>
                        </tr>
                    )
                })
            )
        } else {
            emptyScreen = (
                <EmptyScreen item="Stories" />
            )
        }

        // let companyList12 = populateCompanyList();
        // console.log("companyyy list return: " ,companyList12);



        return (
            <div className="bodyWrapper" onClick={this.eventHandleClick}>
                <Header />
                <section className="listing_header">
                    <h1> Story Listing</h1>
                    {purchaseId && <div>
                        <Link to={`/companies/${this.props.params.centralCompanyId}/purchases`}>← Back to purchases</Link>
                        <p>Purchase ID: {purchaseId}</p>
                    </div>}
                    {!purchaseId && <>
                    <div className="wrapperButton" onClick={this.redirectHandlerAddStory}>
                        Add New Story
                    </div>
                    <div className="wrapperButton" onClick={this.redirectHandlerAllStory}>
                        All Company Stories
                    </div>
                    </>}
                    <div className="wrapper">
                        {!purchaseId && <div className="wrapperForm">
                            <div className="form-group">
                                <label>Company List:</label>
                                {/* <select  onChange={(e) => this.setCompanyID(e)} name="company" className="ele_spacing2">
                                    <option>Select Company</option>
                                    {this.companyListing}
                                    <PopulateCompanyList
                                        key={1}
                                    />
                                    {companyList12}
                                </select> */}
                                {/* <select  onChange={(e) => this.setCompanyID(e)} name="company" className="ele_spacing2"><option value="">Select Company</option><option value="5c9a2c1a21854d57ff97ba80">Asian Paints</option><option value="5c9a2c1a21854d57ff97ba7f">Amway</option><option value="5c9a2c1a21854d57ff97ba82">Cargill India Private Limited</option><option value="5c9a2c1a21854d57ff97ba84">Cropin Technology Solutions</option><option value="5c9a2c1a21854d57ff97ba81">Bajaj Allianz</option><option value="5c9a2c1a21854d57ff97ba85">Franklin Templeton</option><option value="5c9a2c1a21854d57ff97ba89">HGS</option><option value="5c9a2c1a21854d57ff97ba88">GAP</option><option value="5c9a2c1a21854d57ff97ba8d">Kellogg</option><option value="5c9a2c1a21854d57ff97ba8e">LIVSPACE</option><option value="5c9a2c1a21854d57ff97ba93">Nestle</option><option value="5c9a2c1a21854d57ff97ba92">Mondelez</option><option value="5c9a2c1a21854d57ff97ba97">Shell</option><option value="5c9a2c1a21854d57ff97ba9c">Trafigura</option><option value="5c9a2c1a21854d57ff97baa1">Accenture</option><option value="5c9a2c1a21854d57ff97baa6">redBus.in</option><option value="5c9a2c1a21854d57ff97ba86">Future Group</option><option value="5c9a2c1a21854d57ff97ba98">Societe Generale</option><option value="5c9a2c1a21854d57ff97ba9d">UST Global</option><option value="5c9a2c1a21854d57ff97ba8b">Infosys</option><option value="5c9a2c1a21854d57ff97baa2">Amazon.com</option><option value="5c9a2c1a21854d57ff97ba90">MakeMyTrip</option><option value="5c9a2c1a21854d57ff97baa7">synchrony</option><option value="5c9a2c1a21854d57ff97ba95">PepsiCo</option><option value="5c9a2c1a21854d57ff97ba8a">IBM</option><option value="5c9a2c1a21854d57ff97ba9a">Swiggy</option><option value="5c9a2c1a21854d57ff97ba8f">L'Oreal</option><option value="5c9a2c1a21854d57ff97ba9f">Xiaomi</option><option value="5c9a2c1a21854d57ff97ba94">OLA cabs</option><option value="5c9a2c1a21854d57ff97baa4">Brillio</option><option value="5c9a2c1a21854d57ff97ba99">Sutherland</option><option value="5c9a2c1a21854d57ff97baa9">Synechron</option><option value="5c9a2c1a21854d57ff97ba9e">WNS</option><option value="5c9a2c1a21854d57ff97ba83">Cloudtail</option><option value="5c9a2c1a21854d57ff97baa3">American Express</option><option value="5c9a2c1a21854d57ff97ba87">GSK</option><option value="5c9a2c1a21854d57ff97baa8">Uber</option><option value="5c9a2c1a21854d57ff97ba8c">Invesco</option><option value="5c9a2c1a21854d57ff97ba91">MetricStream</option><option value="5c9a2c1a21854d57ff97ba96">Reliance Industries Limited</option><option value="5c9a2c1a21854d57ff97ba9b">Titan Industries</option><option value="5c9a2c1a21854d57ff97baa0">ZS</option><option value="5c9a2c1a21854d57ff97baa5">Coca Cola</option><option value="5c9db83fd2b2166668895e06">iimjobs</option><option value="5c9db890d2b2166668895e08">hirist</option><option value="5c9db8a9d2b2166668895e09">testing</option></select> */}
                                <select onChange={(e) => this.setCompanyID(e)}>
                                    {this.state.companies.map((item) => <option key={item.value} value={item.value}>{item.display}</option>)}
                                </select>
                                <button type="submit" id="btnSubmit" className="btn-default" onClick={(e) => this.onSubmit(e)}>GO</button>
                                <button className="publishButton btn-default color_green hidden" onClick={this.onPublish}>Publish</button>
                            </div>
                        </div>

                        }
                        {purchaseId && this.state.purchaseLoading && <p role="status">Loading stories…</p>}
                        {purchaseId && this.state.purchaseError && <div role="alert">
                            <p>{this.state.purchaseError}</p>
                            <button type="button" onClick={() => this.loadPurchaseStories(this.state.purchasePage)}>Retry</button>
                        </div>}
                        <div className="wrapperTable">
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                <tbody>
                                    <tr className="table-header">
                                        {/* <th className="table_header">Select</th> */}
                                        <th className="table_header">Story ID</th>
                                        <th className="table_header">Story</th>
                                        <th className="table_header">Thumbnail</th>
                                        {toShowPublishType && (<th className="table_header ">Publish Type</th>)}
                                        <th className="table_header">Status</th>
                                        <th className="table_header">Published On</th>
                                        <th className="table_header ">Actions</th>
                                        <th className="table_header adminCheckHidden">Created On</th>
                                        <th className="table_header adminCheckHidden">Expiry</th>
                                        <th className="table_header">Claps</th>
                                        <th className="table_header">Views</th>
                                        <th className="table_header">Swipe Up</th>
                                        <th className="table_header">View Insights</th>
                                    </tr>
                                    {activeStoryRows}
                                </tbody>
                            </table>
                            {!this.state.purchaseLoading && !this.state.purchaseError && emptyScreen}
                            {purchaseId && !this.state.purchaseError && <nav aria-label="Story pagination">
                                <button type="button" disabled={this.state.purchaseLoading || this.state.purchasePage === 0}
                                    onClick={() => this.loadPurchaseStories(this.state.purchasePage - 1)}>Previous</button>
                                <span> Page {this.state.purchasePage + 1} of {Math.max(1, Math.ceil(this.state.purchaseTotal / 10))} · {this.state.purchaseTotal} stories </span>
                                <button type="button" disabled={this.state.purchaseLoading || (this.state.purchasePage + 1) * 10 >= this.state.purchaseTotal}
                                    onClick={() => this.loadPurchaseStories(this.state.purchasePage + 1)}>Next</button>
                            </nav>}
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Story);    